export default __webpack_public_path__ + "static/media/SWT0950.34I-36802_-21671_0.b760ea6a.jpg";